import React from "react";

import { LoadingOverlay } from "@mantine/core";

export const RouterLoadingComponent = React.memo(
  function RouterLoadingComponent() {
    return (
      <LoadingOverlay
        visible
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 3 }}
      />
    );
  },
);
